import { render, staticRenderFns } from "./SolidBackgroundColor.vue?vue&type=template&id=1a29e33e"
import script from "./SolidBackgroundColor.vue?vue&type=script&lang=js"
export * from "./SolidBackgroundColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports